<template>
  <div class="max-w-screen-xl m-auto" :class="{ 'h-screen overflow-hidden': needsMigrate }">
    <div>
      <div class="flex flex-col h-screen justify-between">
        <Header
          :user-data="userData"
          :character-data="characterData"
          :character-private-data="characterPrivateData"
          :loading="loading"
        />

        <div v-if="isBanned" class="fixed inset-0 flex items-center justify-center z-50">
          <div class="fixed inset-0 bg-black bg-opacity-50 backdrop-blur-sm"></div>
          <BannedModal />
        </div>

        <!-- ZombieFightModal -->
        <div v-if="shouldShowZombieFightModal && !isZombieFightModalClosed" class="fixed inset-0 flex items-center justify-center z-50">
          <div class="fixed inset-0 bg-black bg-opacity-50 backdrop-blur-sm"></div>
          <ZombieFightModal :eventId="characterPrivateData?.event" @fightCompleted="handleModalClose" @close="closeZombieFightModal" />
        </div>

        <!-- SupernaturalEventModal -->
        <div v-if="shouldShowSupernaturalEventModal && !isSupernaturalEventModalClosed" class="fixed inset-0 flex items-center justify-center z-50">
          <div class="fixed inset-0 bg-black bg-opacity-50 backdrop-blur-sm"></div>
          <SupernaturalEventModal :eventId="characterPrivateData?.event" @fightCompleted="handleModalClose" @close="closeSupernaturalEventModal" />
        </div>

        <!-- GhostPvpModal -->
        <div v-if="shouldShowGhostPvpModal && !isGhostPvpModalClosed" class="fixed inset-0 flex items-center justify-center z-50">
          <div class="fixed inset-0 bg-black bg-opacity-50 backdrop-blur-sm"></div>
          <GhostPvpModal :eventId="characterPrivateData?.event" @pvpCompleted="handleModalClose" @close="closeGhostPvpModal" />
        </div>

        <!-- AttackRoomGuardianGhostModal -->
        <div v-if="shouldShowAttackRoomGuardianGhostModal && !isAttackRoomGuardianGhostModalClosed" class="fixed inset-0 flex items-center justify-center z-50">
          <div class="fixed inset-0 bg-black bg-opacity-50 backdrop-blur-sm"></div>
          <AttackRoomGuardianGhostModal :eventId="characterPrivateData?.event" @fightCompleted="handleModalClose" @close="closeAttackRoomGuardianGhostModal" />
        </div>

        <!-- GuardianGhostModal -->
        <div v-if="shouldShowGuardianGhostModal" class="fixed inset-0 flex items-center justify-center z-50">
          <div class="fixed inset-0 bg-black bg-opacity-50 backdrop-blur-sm"></div>
          <GuardianGhostModal
            :eventId="characterPrivateData?.event"
            :visible="shouldShowGuardianGhostModal"
            @closeModal="closeGuardianGhostModal"
          />
        </div>

        <!-- KillerRobotModal -->
        <div v-if="shouldShowKillerRobotModal" class="fixed inset-0 flex items-center justify-center z-50">
          <div class="fixed inset-0 bg-black bg-opacity-50 backdrop-blur-sm"></div>
          <KillerRobotModal :eventId="characterPrivateData?.event" />
        </div>

        <!-- MigrateItemModal -->
        <Teleport to="body">
          <div
            v-if="needsMigrate && !isBanned && user"
            class="fixed inset-0 flex items-center justify-center px-4"
            style="z-index: 100000;"
          >
            <div class="absolute inset-0 bg-black bg-opacity-80 migrate-modal-backdrop"></div>

            <div
              class="relative w-full max-w-md mx-auto rounded-2xl shadow-2xl border border-yellow-400 overflow-hidden migrate-modal-card"
            >
              <div class="absolute inset-x-0 top-0 h-1 bg-yellow-400"></div>

              <MigrateItemModal
                :user-id="user.uid"
                @migrated="needsMigrate = false"
              />
            </div>
          </div>
        </Teleport>

        <!-- RecoveryBornModal -->
        <div v-if="shouldShowRecoveryBornModal && !needsMigrate" class="fixed inset-0 flex items-center justify-center z-50">
          <div class="fixed inset-0 bg-black bg-opacity-50 backdrop-blur-sm"></div>
          <RecoveryBornModal @recoverCompleted="handleModalClose" />
        </div>

        <!-- BornModal -->
        <div v-if="shouldShowBornModal && !needsMigrate" class="fixed inset-0 flex items-center justify-center z-50">
          <div class="fixed inset-0 bg-black bg-opacity-50 backdrop-blur-sm"></div>
          <BornModal :eventId="characterPrivateData?.event" @bornCompleted="handleModalClose" />
        </div>

        <!-- RoomGuardianGhostModal -->
        <div v-if="shouldShowRoomGuardianGhostModal" class="fixed inset-0 flex items-center justify-center z-50">
          <div class="fixed inset-0 bg-black bg-opacity-50 backdrop-blur-sm"></div>
          <RoomGuardianGhostModal
            :eventId="characterPrivateData?.event"
            :visible="shouldShowRoomGuardianGhostModal"
            @closeModal="hideModal"
          />
        </div>

        <!-- WaitingLootModal -->
        <div v-if="shouldShowWaitingLootModal && !isWaitingLootModalClosed" class="fixed inset-0 flex items-center justify-center z-50">
          <div class="fixed inset-0 bg-black bg-opacity-50 backdrop-blur-sm"></div>
          <WaitingLootModal :eventId="characterPrivateData?.event" @waitingCompleted="handleModalClose" @close="closeWaitingLootModal" />
        </div>

        <!-- KillerRobotListModal -->
        <div v-if="shouldShowRobotListModal" class="fixed inset-0 flex items-center justify-center z-50">
          <div class="fixed inset-0 bg-black bg-opacity-50 backdrop-blur-sm"></div>
          <KillerRobotListModal :active-robots="activeRobots" @close="closeRobotListModal" />
        </div>

        <!-- MarketplaceModal -->
        <div v-if="shouldShowMarketplaceModal" class="fixed inset-0 flex items-center justify-center z-50">
          <div class="fixed inset-0 bg-black bg-opacity-50 backdrop-blur-sm"></div>
          <MarketplaceModal :eventId="characterPrivateData?.event" @close="closeMarketplaceModal" />
        </div>

        <!-- GhostItemsModal -->
        <div v-if="shouldShowGhostItemsModal" class="fixed inset-0 flex items-center justify-center z-50">
          <div class="fixed inset-0 bg-black bg-opacity-50 backdrop-blur-sm"></div>
          <GhostItemsModal @close="closeGhostItemsModal" @use-magic="handleGhostMagic" />
        </div>

        <!-- AttackOutpostModal -->
        <div v-if="shouldShowAttackOutpostModal && !isAttackOutpostModalClosed" class="fixed inset-0 flex items-center justify-center z-50">
          <div class="fixed inset-0 bg-black bg-opacity-50 backdrop-blur-sm"></div>
          <AttackOutpostModal :eventId="attackOutpostEventId" @fightCompleted="handleModalClose" @close="closeAttackOutpostModal" />
        </div>

        <!-- DefenseOutpostFromNpcModal -->
        <div v-if="selectedDefenseOutpostFromNpcEventId !== null" class="fixed inset-0 flex items-center justify-center z-50">
          <div class="fixed inset-0 bg-black bg-opacity-50 backdrop-blur-sm"></div>
          <DefenseOutpostFromNpc :eventId="selectedDefenseOutpostFromNpcEventId" @close="closeDefenseOutpostFromNpcModal" />
        </div>

        <!-- TrapActiveModal -->
        <div v-if="shouldShowTrapActiveModal" class="fixed inset-0 flex items-center justify-center z-50">
          <div class="fixed inset-0 bg-black bg-opacity-50 backdrop-blur-sm"></div>
          <TrapActiveModal
            :eventId="characterPrivateData?.event"
            :visible="shouldShowTrapActiveModal"
            @closeModal="hideModal"
          />
        </div>

        <!-- Floating Buttons Container -->
        <div
          v-if="!needsMigrate && !shouldShowTrapActiveModal && !shouldShowRobotListModal && !shouldShowRoomGuardianGhostModal && !shouldShowGuardianGhostModal"
          class="fixed bottom-20 left-1/2 transform -translate-x-1/2 z-50 flex flex-row items-center gap-4"
          style="padding-bottom: env(safe-area-inset-bottom);"
        >
          <button
            v-if="characterPrivateData?.event && eventData && eventData.type === 'trap' && !eventData.finished"
            @click="openTrapModal"
            class="bg-yellow-600 text-white rounded-full w-12 h-12 flex items-center justify-center shadow-lg hover:bg-yellow-700 transition-all duration-200 focus:outline-none focus:ring-2 focus:ring-yellow-500"
            title="เปิดโมดอลกับดัก"
          >
            <i class="fa-solid fa-road-spikes text-lg"></i>
          </button>

          <button
            v-if="characterPrivateData?.event && eventData && eventData.type === 'roomGuardianGhost' && !eventData.finished"
            @click="openRoomGuardianGhostModal"
            class="bg-purple-600 text-white rounded-full w-12 h-12 flex items-center justify-center shadow-lg hover:bg-purple-700 transition-all duration-200 focus:outline-none focus:ring-2 focus:ring-purple-500"
            title="เปิดโมดอลวิญญาณเฝ้าห้อง"
          >
            <i class="fas fa-ghost text-lg"></i>
          </button>

          <button
            v-if="characterPrivateData?.event && eventData && eventData.type === 'guardianGhost' && !eventData.finished"
            @click="openGuardianGhostModal"
            class="bg-green-600 text-white rounded-full w-12 h-12 flex items-center justify-center shadow-lg hover:bg-green-700 transition-all duration-200 focus:outline-none focus:ring-2 focus:ring-green-500"
            title="เปิดโมดอลวิญญาณผู้พิทักษ์"
          >
            <i class="fas fa-shield-alt text-lg"></i>
          </button>

          <button
            v-if="characterPrivateData?.event && eventData && eventData.type === 'attackRoomGuardianGhost' && !eventData.finished && isAttackRoomGuardianGhostModalClosed"
            @click="openAttackRoomGuardianGhostModal"
            class="bg-purple-600 text-white rounded-full w-12 h-12 flex items-center justify-center shadow-lg hover:bg-purple-700 transition-all duration-200 focus:outline-none focus:ring-2 focus:ring-purple-500"
            title="เปิดโมดอลต่อสู้วิญญาณเฝ้าห้อง"
          >
            <i class="fas fa-ghost text-lg"></i>
          </button>

          <button
            v-if="hasActiveRobots"
            @click="openRobotListModal"
            class="bg-purple-600 text-white rounded-full w-12 h-12 flex items-center justify-center shadow-lg hover:bg-purple-700 transition-all duration-200 focus:outline-none focus:ring-2 focus:ring-purple-500"
            title="เปิดรายการหุ่นยนต์นักฆ่า"
          >
            <i class="fa-solid fa-robot text-lg"></i>
          </button>

          <button
            v-if="shouldShowZombieFightModal && isZombieFightModalClosed"
            @click="openZombieFightModal"
            class="bg-red-600 text-white rounded-full w-12 h-12 flex items-center justify-center shadow-lg hover:bg-red-700 transition-all duration-200 focus:outline-none focus:ring-2 focus:ring-red-500"
            title="เปิดโมดอลต่อสู้ซอมบี้"
          >
            <i class="fas fa-skull-crossbones text-lg"></i>
          </button>

          <button
            v-if="shouldShowSupernaturalEventModal && isSupernaturalEventModalClosed"
            @click="openSupernaturalEventModal"
            class="bg-red-600 text-white rounded-full w-12 h-12 flex items-center justify-center shadow-lg hover:bg-red-700 transition-all duration-200 focus:outline-none focus:ring-2 focus:ring-red-500"
            title="เปิดโมดอลสำรวจสิ่งเหนือธรรมชาติ"
          >
            <i class="fas fa-ghost text-lg"></i>
          </button>

          <button
            v-if="shouldShowGhostPvpModal && isGhostPvpModalClosed"
            @click="openGhostPvpModal"
            class="bg-purple-700 text-white rounded-full w-12 h-12 flex items-center justify-center shadow-lg hover:bg-purple-600 transition-all duration-200 focus:outline-none focus:ring-2 focus:ring-purple-500"
            title="เปิดโมดอลต่อสู้ในโลกวิญญาณ"
          >
            <i class="fas fa-skull-crossbones text-lg"></i>
          </button>

          <button
            v-if="characterPrivateData?.event && eventData && eventData.type === 'marketplace' && !eventData.finished"
            @click="openMarketplaceModal"
            class="bg-indigo-600 text-white rounded-full w-12 h-12 flex items-center justify-center shadow-lg hover:bg-indigo-700 transition-all duration-200 focus:outline-none focus:ring-2 focus:ring-indigo-500"
            title="เปิดโมดอลแผงลอย"
          >
            <i class="fas fa-store text-lg"></i>
          </button>

          <button
            v-if="shouldShowWaitingLootModal && isWaitingLootModalClosed"
            @click="openWaitingLootModal"
            class="bg-yellow-600 text-white rounded-full w-12 h-12 flex items-center justify-center shadow-lg hover:bg-yellow-700 transition-all duration-200 focus:outline-none focus:ring-2 focus:ring-yellow-500"
            title="เปิดโมดอลดักรอ"
          >
            <i class="fa-solid fa-mask text-lg"></i>
          </button>

          <button
            v-if="hasEquippedGhosts && !characterPrivateData?.event"
            @click="toggleGhostItemsModal"
            class="bg-purple-600 text-white rounded-full w-12 h-12 flex items-center justify-center shadow-lg hover:bg-purple-700 transition-all duration-200 focus:outline-none focus:ring-2 focus:ring-purple-500"
            :title="shouldShowGhostItemsModal ? 'ปิดโมดอลไอเทมวิญญาณ' : 'เปิดโมดอลไอเทมวิญญาณ'"
          >
            <i class="fas fa-ghost text-lg"></i>
          </button>

          <button
            v-if="shouldShowAttackOutpostModal && isAttackOutpostModalClosed"
            @click="openAttackOutpostModal"
            class="bg-red-600 text-white rounded-full w-12 h-12 flex items-center justify-center shadow-lg hover:bg-red-700 transition-all duration-200 focus:outline-none focus:ring-2 focus:ring-red-500"
            title="เปิดโมดอลบุกยึด outpost"
          >
            <i class="fas fa-fist-raised text-lg"></i>
          </button>

          <button
            v-for="eventId in defenseOutpostFromNpcEventIds"
            :key="eventId"
            @click="openDefenseOutpostFromNpcModal(eventId)"
            class="bg-red-600 text-white rounded-full w-12 h-12 flex items-center justify-center shadow-lg hover:bg-red-700 transition-all duration-200 focus:outline-none focus:ring-2 focus:ring-red-500"
            title="เปิดโมดอลป้องกัน outpost จาก NPC"
          >
            <i class="fas fa-tower-observation text-lg"></i>
          </button>
        </div>

        <router-view />

        <BottomMenu
          v-if="!needsMigrate"
          :character-private-data="characterPrivateData"
          :user-data="userData"
          :character-data="characterData"
        />
      </div>
    </div>
  </div>
</template>

<script>
import { ref, onMounted, onUnmounted, watch, computed } from 'vue';
import { projectFirestore, projectFunctions } from '@/firebase/config';
import getUser from '@/composables/getUser';
import { usePlayerStore } from '@/composables/usePlayerStore';
import { useInventoryStore } from '@/composables/useInventoryStore';
import { useMissionStatsStore } from '@/composables/useMissionStatsStore';
import Header from './components/Header.vue';
import ZombieFightModal from './components/character/ZombieFightModal.vue';
import SupernaturalEventModal from './components/character/SupernaturalEventModal.vue';
import AttackRoomGuardianGhostModal from './components/character/AttackRoomGuardianGhostModal.vue';
import GuardianGhostModal from './components/character/GuardianGhostModal.vue';
import KillerRobotModal from './components/character/KillerRobotModal.vue';
import BornModal from './components/character/BornModal.vue';
import RecoveryBornModal from './components/character/RecoveryBornModal.vue';
import BannedModal from './components/BannedModal.vue';
import MigrateItemModal from './components/MigrateItemModal.vue';
import TrapActiveModal from './components/character/TrapActiveModal.vue';
import KillerRobotListModal from './components/character/KillerRobotListModal.vue';
import WaitingLootModal from './components/character/WaitingLoot.vue';
import MarketplaceModal from './components/character/MarketplaceModal.vue';
import GhostItemsModal from './components/character/GhostItemsModal.vue';
import RoomGuardianGhostModal from './components/character/RoomGuardianGhostModal.vue';
import AttackOutpostModal from './components/AttackOutpostModal.vue';
import DefenseOutpostFromNpc from './components/DefenseOutpostFromNpc.vue';
import GhostPvpModal from './components/character/GhostPvpModal.vue';
import BottomMenu from './components/BottomMenu.vue';

export default {
  components: {
    Header,
    ZombieFightModal,
    SupernaturalEventModal,
    AttackRoomGuardianGhostModal,
    GuardianGhostModal,
    KillerRobotModal,
    BornModal,
    RecoveryBornModal,
    BannedModal,
    MigrateItemModal,
    TrapActiveModal,
    KillerRobotListModal,
    WaitingLootModal,
    MarketplaceModal,
    GhostItemsModal,
    RoomGuardianGhostModal,
    AttackOutpostModal,
    DefenseOutpostFromNpc,
    GhostPvpModal,
    BottomMenu
  },

  setup() {
    const { user, isLoadingAuth } = getUser();
    const playerStore = usePlayerStore();
    const inventoryStore = useInventoryStore();
    const missionStatsStore = useMissionStatsStore();

    const userData = ref(null);
    const characterData = ref(null);
    const characterPrivateData = ref(null);
    const eventData = ref(null);

    const isBanned = ref(false);
    const needsMigrate = ref(false);
    const loading = ref(true);

    const isZombieFightModalClosed = ref(false);
    const isSupernaturalEventModalClosed = ref(false);
    const isAttackRoomGuardianGhostModalClosed = ref(false);
    const isWaitingLootModalClosed = ref(false);
    const isAttackOutpostModalClosed = ref(false);
    const isGhostPvpModalClosed = ref(false);

    const hasActiveRobots = ref(false);
    const activeRobots = ref([]);
    const attackOutpostEventId = ref(null);
    const defenseOutpostFromNpcEventIds = ref([]);
    const selectedDefenseOutpostFromNpcEventId = ref(null);

    let unsubscribeEvent = null;
    let unsubscribeRobots = null;
    let unsubscribeAttackOutpost = null;
    let unsubscribeDefenseOutpostFromNpc = null;
    let dataFetched = false;

    const hasEquippedGhosts = computed(() => {
      return characterPrivateData.value?.ghostItemIds?.length > 0;
    });

    const fetchIPAddress = () => {
      return fetch('https://api4.ipify.org?format=json')
        .then((response) => response.json())
        .then((data) => {
          if (data.ip.indexOf('.') === -1 || data.ip.indexOf(':') !== -1) return;

          if (user.value) {
            const updateIp = projectFunctions.httpsCallable('gameActions');
            return updateIp({
              action: 'characterActions',
              subAction: 'updateIp',
              ip: data.ip
            }).then((result) => {
              console.log('IP updated:', result);
            });
          }
        })
        .catch((error) => {
          console.error('Error fetching IP:', error);
        });
    };

    const fetchData = () => {
      if (!user.value || isBanned.value || dataFetched) {
        loading.value = false;
        return;
      }

      dataFetched = true;
      const userId = user.value.uid;

      playerStore.init(userId);
      inventoryStore.init(userId);

      unsubscribeRobots = projectFirestore.collection('killerRobots')
        .where('ownerUid', '==', userId)
        .where('isLive', '==', true)
        .onSnapshot((snap) => {
          activeRobots.value = snap.docs.map(doc => ({
            ...doc.data(),
            id: doc.id,
            killerRobotId: doc.id
          }));
          hasActiveRobots.value = activeRobots.value.length > 0;
        });

      unsubscribeAttackOutpost = projectFirestore.collection('events')
        .where('characterId', '==', userId)
        .where('type', '==', 'attackOutpost')
        .where('finished', '==', false)
        .onSnapshot((snap) => {
          attackOutpostEventId.value = snap.docs.length === 1 ? snap.docs[0].id : null;
        });

      unsubscribeDefenseOutpostFromNpc = projectFirestore.collection('events')
        .where('characterId', '==', userId)
        .where('type', '==', 'defenseOutpostFromNpc')
        .where('finished', '==', false)
        .onSnapshot((snap) => {
          defenseOutpostFromNpcEventIds.value = snap.docs.map(doc => doc.id);
        });
    };

    const resetModalState = () => {
      isZombieFightModalClosed.value = false;
      isSupernaturalEventModalClosed.value = false;
      isAttackRoomGuardianGhostModalClosed.value = false;
      isWaitingLootModalClosed.value = false;
      isAttackOutpostModalClosed.value = false;
      isGhostPvpModalClosed.value = false;

      shouldShowMarketplaceModal.value = false;
      shouldShowGhostItemsModal.value = false;
      shouldShowRoomGuardianGhostModal.value = false;
      shouldShowGuardianGhostModal.value = false;
      shouldShowTrapActiveModal.value = false;
    };

    const subscribeToEventData = (eventId) => {
      if (!eventId) {
        eventData.value = null;

        if (unsubscribeEvent) {
          unsubscribeEvent();
          unsubscribeEvent = null;
        }

        return;
      }

      if (unsubscribeEvent) {
        unsubscribeEvent();
        unsubscribeEvent = null;
      }

      unsubscribeEvent = projectFirestore.collection('events').doc(eventId).onSnapshot(
        (doc) => {
          eventData.value = doc.exists ? doc.data() : null;

          if (!doc.exists || doc.data()?.finished) {
            resetModalState();
          }
        },
        (err) => {
          console.error('Error fetching event data:', err);
          eventData.value = null;
          resetModalState();
        }
      );
    };

    const shouldShowZombieFightModal = computed(() => (
      characterPrivateData.value?.event &&
      eventData.value?.type === 'fightZombie' &&
      !eventData.value?.finished
    ));

    const shouldShowSupernaturalEventModal = computed(() => (
      characterPrivateData.value?.event &&
      ['exploreSupernatural', 'fightGhost'].includes(eventData.value?.type) &&
      !eventData.value?.finished
    ));

    const shouldShowAttackRoomGuardianGhostModal = computed(() => (
      characterPrivateData.value?.event &&
      eventData.value?.type === 'attackRoomGuardianGhost' &&
      !eventData.value?.finished
    ));

    const shouldShowKillerRobotModal = computed(() => (
      characterPrivateData.value?.event &&
      eventData.value?.type === 'killerRobot' &&
      !eventData.value?.finished
    ));

    const shouldShowBornModal = computed(() => (
      characterPrivateData.value?.event &&
      eventData.value?.type === 'Born' &&
      !eventData.value?.finished
    ));

    const shouldShowRecoveryBornModal = computed(() => {
      if (needsMigrate.value || isBanned.value || !user.value || loading.value) return false;
      if (!characterData.value || !characterPrivateData.value) return false;

      const isDead = characterData.value.isLive === false && characterPrivateData.value.isLive === false;
      if (!isDead) return false;

      const eventId = characterPrivateData.value.event;
      const isNormalBorn = eventId && eventData.value?.type === 'Born' && !eventData.value?.finished;

      // ถ้าเป็น Born ปกติ ไม่ต้องแสดง Recovery
      if (isNormalBorn) return false;

      // ไม่มี eventId เลย หรือมี eventId แต่ fetch ไม่เจอ
      if (!eventId) return true;
      if (eventId && eventData.value === null) return true;

      return false;
    });

    const shouldShowWaitingLootModal = computed(() => (
      characterPrivateData.value?.event &&
      eventData.value?.type === 'waiting_loot' &&
      !eventData.value?.finished
    ));

    const shouldShowGhostPvpModal = computed(() => (
      characterPrivateData.value?.event &&
      eventData.value?.type === 'ghostPvp' &&
      !eventData.value?.finished
    ));

    const shouldShowAttackOutpostModal = ref(false);
    const shouldShowTrapActiveModal = ref(false);
    const shouldShowRoomGuardianGhostModal = ref(false);
    const shouldShowGuardianGhostModal = ref(false);
    const shouldShowRobotListModal = ref(false);
    const shouldShowMarketplaceModal = ref(false);
    const shouldShowGhostItemsModal = ref(false);

    watch(attackOutpostEventId, (newVal) => {
      shouldShowAttackOutpostModal.value = !!newVal;
    });

    const updateNeedsMigrate = () => {
      if (!user.value || isBanned.value) {
        needsMigrate.value = false;
        return;
      }

      const msData = inventoryStore.mysteriousStorageData;

      if (msData && Array.isArray(msData.inventory)) {
        needsMigrate.value = msData.inventory.length > 0;
      } else {
        const data = playerStore.userData;
        needsMigrate.value = data ? !data.migratedToItemV2 : false;
      }
    };

    watch(() => playerStore.userData, (data) => {
      userData.value = data;

      if (data) {
        isBanned.value = data.ban || false;
      } else {
        isBanned.value = false;
      }

      updateNeedsMigrate();
    }, { immediate: true });

    watch(() => inventoryStore.mysteriousStorageData, () => {
      updateNeedsMigrate();
    }, { immediate: true });

    watch(() => playerStore.characterData, (data) => {
      characterData.value = data;
    }, { immediate: true });

    watch(() => playerStore.characterPrivateData, (data) => {
      characterPrivateData.value = data;

      if (data && data.event) {
        subscribeToEventData(data.event);
      } else {
        eventData.value = null;

        if (unsubscribeEvent) {
          unsubscribeEvent();
          unsubscribeEvent = null;
        }

        shouldShowTrapActiveModal.value = false;
        shouldShowRoomGuardianGhostModal.value = false;
        shouldShowGuardianGhostModal.value = false;
        shouldShowMarketplaceModal.value = false;
        shouldShowGhostItemsModal.value = false;
        shouldShowAttackOutpostModal.value = false;
      }
    }, { immediate: true });

    watch(() => playerStore.loading, (val) => {
      loading.value = val;
    }, { immediate: true });

    watch(needsMigrate, (val) => {
      if (typeof document === 'undefined') return;

      if (val) {
        document.body.classList.add('overflow-hidden');
      } else {
        document.body.classList.remove('overflow-hidden');
      }
    }, { immediate: true });

    const openTrapModal = () => {
      shouldShowTrapActiveModal.value = true;
    };

    const openRoomGuardianGhostModal = () => {
      shouldShowRoomGuardianGhostModal.value = true;
    };

    const openGuardianGhostModal = () => {
      shouldShowGuardianGhostModal.value = true;
    };

    const closeGuardianGhostModal = () => {
      shouldShowGuardianGhostModal.value = false;
    };

    const openAttackRoomGuardianGhostModal = () => {
      isAttackRoomGuardianGhostModalClosed.value = false;
    };

    const closeAttackRoomGuardianGhostModal = () => {
      isAttackRoomGuardianGhostModalClosed.value = true;
    };

    const hideModal = () => {
      shouldShowTrapActiveModal.value = false;
      shouldShowRoomGuardianGhostModal.value = false;
      shouldShowGuardianGhostModal.value = false;
    };

    const openRobotListModal = () => {
      shouldShowRobotListModal.value = true;
    };

    const closeRobotListModal = () => {
      shouldShowRobotListModal.value = false;
    };

    const openZombieFightModal = () => {
      isZombieFightModalClosed.value = false;
    };

    const closeZombieFightModal = () => {
      isZombieFightModalClosed.value = true;
    };

    const openSupernaturalEventModal = () => {
      isSupernaturalEventModalClosed.value = false;
    };

    const closeSupernaturalEventModal = () => {
      isSupernaturalEventModalClosed.value = true;
    };

    const openWaitingLootModal = () => {
      isWaitingLootModalClosed.value = false;
    };

    const closeWaitingLootModal = () => {
      isWaitingLootModalClosed.value = true;
    };

    const openMarketplaceModal = () => {
      shouldShowMarketplaceModal.value = true;
    };

    const closeMarketplaceModal = () => {
      shouldShowMarketplaceModal.value = false;
    };

    const toggleGhostItemsModal = () => {
      shouldShowGhostItemsModal.value = !shouldShowGhostItemsModal.value;
    };

    const closeGhostItemsModal = () => {
      shouldShowGhostItemsModal.value = false;
    };

    const openAttackOutpostModal = () => {
      isAttackOutpostModalClosed.value = false;
    };

    const closeAttackOutpostModal = () => {
      isAttackOutpostModalClosed.value = true;
    };

    const openDefenseOutpostFromNpcModal = (id) => {
      selectedDefenseOutpostFromNpcEventId.value = id;
    };

    const closeDefenseOutpostFromNpcModal = () => {
      selectedDefenseOutpostFromNpcEventId.value = null;
    };

    const openGhostPvpModal = () => {
      isGhostPvpModalClosed.value = false;
    };

    const closeGhostPvpModal = () => {
      isGhostPvpModalClosed.value = true;
    };

    const handleGhostMagic = ({ itemId, cooldownUntil, eventId, subtype }) => {
      console.log('Ghost magic used:', {
        itemId,
        cooldownUntil,
        eventId,
        subtype
      });

      if (eventId) {
        characterPrivateData.value.event = eventId;
      }

      if (subtype === 'วิญญาณผู้พิทักษ์') {
        shouldShowGuardianGhostModal.value = true;
      } else if (subtype === 'วิญญาณเฝ้าห้อง') {
        shouldShowRoomGuardianGhostModal.value = true;
      }
    };

    const handleModalClose = () => {
      characterPrivateData.value.event = null;
      characterPrivateData.value.damageTaken = 0;
      eventData.value = null;

      if (unsubscribeEvent) {
        unsubscribeEvent();
        unsubscribeEvent = null;
      }

      shouldShowTrapActiveModal.value = false;
      shouldShowRoomGuardianGhostModal.value = false;
      shouldShowGuardianGhostModal.value = false;
      shouldShowMarketplaceModal.value = false;
      shouldShowGhostItemsModal.value = false;
      shouldShowAttackOutpostModal.value = false;

      isZombieFightModalClosed.value = false;
      isSupernaturalEventModalClosed.value = false;
      isAttackRoomGuardianGhostModalClosed.value = false;
      isWaitingLootModalClosed.value = false;
      isAttackOutpostModalClosed.value = false;
      isGhostPvpModalClosed.value = false;

      selectedDefenseOutpostFromNpcEventId.value = null;
    };

    watch(() => characterPrivateData.value?.event, (newEvent, oldEvent) => {
      if (newEvent !== oldEvent) {
        shouldShowTrapActiveModal.value = false;
        shouldShowRoomGuardianGhostModal.value = false;
        shouldShowGuardianGhostModal.value = false;
        shouldShowMarketplaceModal.value = false;
        shouldShowGhostItemsModal.value = false;
        shouldShowAttackOutpostModal.value = false;

        isZombieFightModalClosed.value = false;
        isSupernaturalEventModalClosed.value = false;
        isAttackRoomGuardianGhostModalClosed.value = false;
        isWaitingLootModalClosed.value = false;
        isAttackOutpostModalClosed.value = false;
        isGhostPvpModalClosed.value = false;
      }
    });

    watch(defenseOutpostFromNpcEventIds, (newIds) => {
      if (!newIds.includes(selectedDefenseOutpostFromNpcEventId.value)) {
        selectedDefenseOutpostFromNpcEventId.value = null;
      }
    });

    onMounted(() => {
      fetchIPAddress();

      if (!isLoadingAuth.value && user.value) {
        fetchData();
      }
    });

    watch([isLoadingAuth, user], ([newLoadingAuth, newUser]) => {
      if (!newLoadingAuth && newUser) {
        fetchData();
      } else if (!newUser) {
        [unsubscribeEvent, unsubscribeRobots, unsubscribeAttackOutpost, unsubscribeDefenseOutpostFromNpc]
          .forEach(fn => {
            if (fn) fn();
          });

        userData.value = null;
        characterData.value = null;
        characterPrivateData.value = null;
        eventData.value = null;

        activeRobots.value = [];
        hasActiveRobots.value = false;
        attackOutpostEventId.value = null;
        defenseOutpostFromNpcEventIds.value = [];
        selectedDefenseOutpostFromNpcEventId.value = null;

        isBanned.value = false;
        needsMigrate.value = false;
        loading.value = false;

        shouldShowTrapActiveModal.value = false;
        shouldShowRoomGuardianGhostModal.value = false;
        shouldShowGuardianGhostModal.value = false;
        shouldShowRobotListModal.value = false;
        shouldShowMarketplaceModal.value = false;
        shouldShowGhostItemsModal.value = false;

        isZombieFightModalClosed.value = false;
        isSupernaturalEventModalClosed.value = false;
        isAttackRoomGuardianGhostModalClosed.value = false;
        isWaitingLootModalClosed.value = false;
        isAttackOutpostModalClosed.value = false;
        isGhostPvpModalClosed.value = false;

        unsubscribeEvent = null;
        unsubscribeRobots = null;
        unsubscribeAttackOutpost = null;
        unsubscribeDefenseOutpostFromNpc = null;
        dataFetched = false;

        playerStore.cleanup();
        inventoryStore.cleanup();
        missionStatsStore.invalidate();
      }
    });

    onUnmounted(() => {
      [unsubscribeEvent, unsubscribeRobots, unsubscribeAttackOutpost, unsubscribeDefenseOutpostFromNpc]
        .forEach(fn => {
          if (fn) fn();
        });

      if (typeof document !== 'undefined') {
        document.body.classList.remove('overflow-hidden');
      }

      playerStore.cleanup();
      inventoryStore.cleanup();
      missionStatsStore.invalidate();
    });

    return {
      user,
      userData,
      characterData,
      characterPrivateData,
      eventData,

      shouldShowZombieFightModal,
      shouldShowSupernaturalEventModal,
      shouldShowAttackRoomGuardianGhostModal,
      shouldShowKillerRobotModal,
      shouldShowBornModal,
      shouldShowRecoveryBornModal,
      shouldShowWaitingLootModal,
      shouldShowAttackOutpostModal,
      shouldShowTrapActiveModal,
      shouldShowRoomGuardianGhostModal,
      shouldShowGuardianGhostModal,
      shouldShowRobotListModal,
      shouldShowMarketplaceModal,
      shouldShowGhostItemsModal,
      shouldShowGhostPvpModal,

      hasActiveRobots,
      activeRobots,
      hasEquippedGhosts,

      openTrapModal,
      openRoomGuardianGhostModal,
      openGuardianGhostModal,
      closeGuardianGhostModal,
      openAttackRoomGuardianGhostModal,
      closeAttackRoomGuardianGhostModal,
      hideModal,
      openRobotListModal,
      closeRobotListModal,
      openZombieFightModal,
      closeZombieFightModal,
      openSupernaturalEventModal,
      closeSupernaturalEventModal,
      openWaitingLootModal,
      closeWaitingLootModal,
      openMarketplaceModal,
      closeMarketplaceModal,
      toggleGhostItemsModal,
      closeGhostItemsModal,
      openAttackOutpostModal,
      closeAttackOutpostModal,
      openDefenseOutpostFromNpcModal,
      closeDefenseOutpostFromNpcModal,
      openGhostPvpModal,
      closeGhostPvpModal,

      handleGhostMagic,
      handleModalClose,

      isBanned,
      needsMigrate,
      loading,

      isZombieFightModalClosed,
      isSupernaturalEventModalClosed,
      isAttackRoomGuardianGhostModalClosed,
      isWaitingLootModalClosed,
      isAttackOutpostModalClosed,
      isGhostPvpModalClosed,

      attackOutpostEventId,
      defenseOutpostFromNpcEventIds,
      selectedDefenseOutpostFromNpcEventId
    };
  }
};
</script>

<style>
#style-1::-webkit-scrollbar {
  width: 8px;
}

#style-1::-webkit-scrollbar-track {
  background: rgba(45, 55, 72, 0.5);
  border-radius: 10px;
}

#style-1::-webkit-scrollbar-thumb {
  background: rgba(74, 85, 104, 0.8);
  border-radius: 10px;
}

#style-1::-webkit-scrollbar-thumb:hover {
  background: rgba(113, 128, 150, 0.9);
}

#style-1 {
  scrollbar-width: thin;
  scrollbar-color: rgba(74, 85, 104, 0.8) rgba(45, 55, 72, 0.5);
}

.migrate-modal-backdrop {
  backdrop-filter: blur(4px);
  -webkit-backdrop-filter: blur(4px);
}

.migrate-modal-card {
  background: #1f2937;
  animation: migrate-modal-pop 0.18s ease-out;
}

@keyframes migrate-modal-pop {
  from {
    opacity: 0;
    transform: scale(0.96) translateY(8px);
  }

  to {
    opacity: 1;
    transform: scale(1) translateY(0);
  }
}
</style>
